import type { SVGProps } from 'react';

const SvgPlayerFlopVertically = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1M7 6h1c.55 0 1-.45 1-1s-.45-1-1-1H7C5.35 4 4 5.35 4 7v10c0 1.65 1.35 3 3 3h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1m9.04 0h1.99S19 6 19 5s-1-1-1-1h-1.96c-.55 0-1 .45-1 1s.45 1 1 1M18 18h-1.95c-.55 0-1 .45-1 1s.45 1 1 1h2.05c.54-.02.94-.47.93-1.02 0-.55-.49-.98-1.04-.98zm2-11.04c-.55 0-1 .45-1 1v2.02c0 .55.45 1 1 1s1-.45 1-1V7.96c0-.55-.45-1-1-1m0 6.05c-.55 0-1 .45-1 1v2.02c0 .55.45 1 1 1s1-.45 1-1v-2.02c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgPlayerFlopVertically;
